import {Injectable} from "@angular/core";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {Client} from "../modal/organization/Client";

@Injectable({
	providedIn: 'root'
})
export class StoreManagerService {
	orgSubject: Subject<Client | null> = new ReplaySubject<Client | null>(1);
	readonly org$: Observable<Client | null> = this.orgSubject.asObservable();

	shortNameSubject: Subject<string | null> = new ReplaySubject<string | null>(1);
	readonly shortName$: Observable<string | null> = this.shortNameSubject.asObservable();

	partnerClientNameSubject: Subject<string | null> = new ReplaySubject<string | null>(1);
	readonly partnerClientName$: Observable<string | null> = this.partnerClientNameSubject.asObservable();

	contextSubject: Subject<string | null> = new ReplaySubject<string | null>(1);
	readonly context$: Observable<string | null> = this.contextSubject.asObservable();
}
